import LocalizedStrings from 'localized-strings';

import { CompanyMandatoryData } from './types';

export const locales = new LocalizedStrings({
  en: {
    activityType: {
      commercial: {
        label: 'Commercial',
      },
      craft: {
        label: 'Craft',
      },
      liberal: {
        label: 'Self-employed',
        no: 'No',
        question: 'Is it a regulated self-employed activity?',
        yes: 'Yes',
      },
      title: 'Nature of main activity',
    },
    companyDetails: {
      callout: {
        conclude: 'To complete your company details, please contact us.',
        cta: 'Contact us',
        title:
          'Your company information is incomplete. In order to obtain a more accurate estimate of your social security contributions, we need:',
      },
      missingData: {
        [CompanyMandatoryData.REGISTRATION_DATE]:
          'To complete your company details, please contact us.',
        [CompanyMandatoryData.ZIP]:
          "Zip code of your company's registered address",
      },
    },
    details: {
      ACRE: 'ACRE',
      activity: 'Activity',
      address: 'Address',
      code: 'NAF / APE code',
      creationDate: 'Date of creation',
      legalName: 'Legal name',
      prelevLib: 'Withholding tax',
      SIRET: 'SIRET',
      title: 'Account details',
    },
    error: 'An error occurred. Please try again.',
    sidebar: {
      commercial: {
        criterias:
          "your Business Formalities Center is the CCI (Chambre de Commerce et d'Industrie);\nyou buy goods or merchandise for the purpose of resale with a view to making a profit (that is, making money, making a benefit);\nyou sell services in the hotel, restaurant, transport, entertainment, security, IT or other industries;\nyou rent out goods, merchandise or services.",
        question: 'How do I know if my activity is considered as commercial?',
        subtitle: 'Your activity is commercial if:',
      },
      craft: {
        criterias:
          "your Business Formalities Center is the CMA (Chambre des Métiers et de l'Artisanat);\nyour activity is registered on the official list of craft trades or arts and crafts activities;\nyour company has fewer than 11 employees at its creation.",
        question: 'How do I know if my activity is considered as craft?',
        subtitle: 'Your activity is considered as craft if:',
      },
      liberal: {
        criterias:
          'your Business Formalities Center is URSSAF;\nyou provide a paid service;\nyou have a diploma or professional qualification in the field.',
        question:
          'How do I know if my activity is considered as self-employed?',
        subtitle:
          'A self-employed activity consists in the provision of mainly intellectual services:',
      },
      reglementedLiberal: {
        firstCriteria:
          'Certain self-employed professions are subject to strict ethical rules overseen by professional bodies (order or chamber). Generally speaking, special regulations apply to the conditions of access to and practice of the profession. Regulated self-employed professions have been classified as self-employed by law, and their titles are protected.',
        question: 'What is a regulated self-employed profession?',
        secondCriteria:
          '**Examples of regulated self-employed professions:** architect, nurse, lawyer, chartered accountant...',
      },
      title: 'Learn more…',
      unreglementedLiberal: {
        firstCriteria:
          'Yes, the unregulated self-employed professions include people who practice a science or art, and whose intellectual activity remains the essence of their activity. Their income must represent the remuneration of personal work, without any subordinate relationship, while engaging their technical and moral responsibility.',
        question: 'Are there any unregulated self-employed professions?',
        secondCriteria:
          '**Examples of unregulated self-employed professions:** developer, historian, town planner, etc.',
      },
    },
    subActivity: {
      question: "What is the company's main activity?",
      selling: 'Sale of goods, catering or accommodation',
      service: 'Services provision',
    },
    title: 'Your company',
  },
  fr: {
    activityType: {
      commercial: {
        label: 'Commerciale',
      },
      craft: {
        label: 'Artisanale',
      },
      liberal: {
        label: 'Libérale',
        no: 'Non',
        question: 'Est-ce une activité libérale réglementée ?',
        yes: 'Oui',
      },
      title: 'Nature de l’activité principale',
    },
    companyDetails: {
      callout: {
        conclude:
          'Pour compléter les détails de votre entreprise, veuillez contacter nos équipes.',
        cta: 'Contacter nos équipes',
        title:
          'Les informations de votre entreprise sont incomplètes. Pour une estimation plus précise de vos cotisations sociales, nous avons besoin de :',
      },
      missingData: {
        [CompanyMandatoryData.REGISTRATION_DATE]:
          'Date de création de votre entreprise',
        [CompanyMandatoryData.ZIP]:
          'Code postal de la commune de domiciliation de votre entreprise',
      },
    },
    details: {
      ACRE: 'ACRE',
      activity: 'Activité',
      address: 'Adresse',
      code: 'Code NAF / APE',
      creationDate: 'Date de création',
      legalName: 'Nom légal',
      prelevLib: 'Prélèvement libératoire',
      SIRET: 'SIRET',
      title: 'Détails du compte',
    },
    error: 'Une erreur est survenue. Veuillez réessayer.',
    sidebar: {
      commercial: {
        criterias:
          "votre Centre des Formalités des Entreprises est la CCI (Chambre de commerce et d'industrie) ;\nvous achetez des biens ou des marchandises pour les revendre dans un but lucratif : qui rapporte de l'argent, du profit, des bénéfices ;\nvous vendez des services dans les domaines de l'hôtellerie, la restauration, les transports, les spectacles, la sécurité, l'informatique, etc. ;\nvous avez une activité de location de biens, de marchandises ou de services.",
        question: 'Comment savoir si mon activité est commerciale ?',
        subtitle: 'Votre activité est commerciale si :',
      },
      craft: {
        criterias:
          "votre Centre des Formalités des Entreprises est la CMA (Chambre des Métiers et de l’Artisanat) ;\nvotre activité fait partie de la liste officielle des métiers de l'artisanat ou de la liste officielle des métiers d'artisanat d'art ;\nvotre entreprise compte moins de 11 salarié·es à sa création.",
        question: 'Comment savoir si mon activité est artisanale ?',
        subtitle: 'Votre activité est artisanale si :',
      },
      liberal: {
        criterias:
          'votre Centre des Formalités des Entreprises est l’URSSAF ;\nvous rendez un service payant ;\nvous avez un diplôme ou une qualification professionnelle dans le domaine.',
        question: 'Comment savoir si mon activité est libérale ?',
        subtitle:
          'Une activité libérale consiste en des prestations de services de nature principalement intellectuelles :',
      },
      reglementedLiberal: {
        firstCriteria:
          "Certaines professions libérales sont soumises à des règles déontologiques strictes contrôlées par des instances professionnelles (ordre ou chambre). Généralement, une réglementation particulière est appliquée sur les conditions d'accès et d'exercice de la profession. Les professions libérales réglementées ont été classées dans le domaine libéral par la loi et leur titre est protégé.",
        question: 'Qu’est-ce qu’une profession libérale réglementée ?',
        secondCriteria:
          '**Exemples de professions libérales réglementées** : architecte, infirmier·e, avocat·e, expert-comptable…',
      },
      title: 'En savoir plus…',
      unreglementedLiberal: {
        firstCriteria:
          "Oui. Les professions libérales non réglementées regroupent des personnes qui pratiquent une science ou un art dont l’activité intellectuelle reste l’essence de leur activité. Leurs recettes doivent représenter la rémunération d'un travail personnel, sans lien de subordination, tout en engageant leur responsabilité technique et morale.",
        question: 'Existe-t-il des professions libérales non réglementées ?',
        secondCriteria:
          '**Exemples de professions libérales non réglementées** : développeur, historien, urbaniste…',
      },
    },
    subActivity: {
      question: 'Quel est le type d’activité principale de l’entreprise ?',
      selling: 'Vente de biens, restauration ou hébergement',
      service: 'Prestation de services',
    },
    title: 'Votre entreprise',
  },
} as const);
